import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';

interface AuthContextType {
  /** Current authenticated user or null */
  user: User | null;
  /** Current session or null */
  session: Session | null;
  /** True while initial session is being loaded */
  loading: boolean;
  /** True if user is authenticated */
  isAuthenticated: boolean;
  /** Sign out the current user */
  signOut: () => Promise<void>;
  /** Get the current access token (for API calls) */
  getAccessToken: () => Promise<string | null>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
